window.CreditoController = ControllerBase.extend({
    name: "CreditoController",
    framework: "knockout",
    bindingRegion: "#credito-cliente-binding",
    reimpressao: 0,
    vencido: 0,
    autorizado: false,
    
    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' },
        ],
        getData: function () {
            var cliente = this.cliente
                ? this.cliente
                : ControllerBase.instances['CadastroClienteController'].model;
            return this.toJS(cliente);
        },
    }),

    ajax: function () {
        return {
            url: "/Cliente/_Credito",
            type: "post",
            cache: false,
            data: global.toJSONString({
                pesquisa: this.pesquisa
            })
        };
    },

    initialize: function (options) {
        this.vendedorTemPermissaoImprimirCreditoCliente = false;
    },

    renderizado: function () {
        vendedorTemPermissaoImprimirCreditoCliente = false;
        global.ajax({
            url: "/Cliente/_ValidarPermissaoImpressaoCredito",
            type: "post",
            success: function (data) {
                if (!data || data.HasErrors || data != 'False') {
                    vendedorTemPermissaoImprimirCreditoCliente = true;
                }
            }
        });
    },

    ObterCreditosClienteSelecionado: function () {
        var creditos = [];
        $.each(this.model.Documentos(),
            function () {
                if (this.Selecionado()) {
                    creditos.push(this.Codigo());
                }
            });

        if (creditos.length == 0) {
            global.showErrorMessage("Por favor, selecione os créditos a serem impressos.");
        }
        return creditos;
    },

    possuiCreditosPendentes: function () {
        if (this.autorizado) {
            return false;
        }
        this.reimpressao = 0;
        this.vencido = 0;
        self = this;
        $.each(this.model.Documentos(),
            function () {
                if (this.Selecionado()) {
                    if (this.NumeroVias() > 0) {
                        self.reimpressao++;
                    }
                    if (this.VencidoParaImpressao()) {
                        self.vencido++;
                    }
                }
            });

        return (this.reimpressao + this.vencido > 0)
    },

    selecionar: function (model) {
        this.autorizado = false;
        if (typeof model.Selecionado != "undefined") {
            model.Selecionado(!model.Selecionado());
        } else {
            this.appendToModel({ name: "Selecionado", value: true });
        }
    },

    selecionarTodos: function () {
        this.autorizado = true;
        if (!this.model.selecionarTodos) {
            this.appendToModel({ name: "selecionarTodos", value: true });
        } else {
            this.model.selecionarTodos(!this.model.selecionarTodos());
        }

        var self = this;
        $.each(this.model.Documentos(),
            function () {
                this.Selecionado(self.model.selecionarTodos());
            });
    },


    validarImpressaoCredito: function (e) {  //FNX-886 - impressao credito

        if (this.ObterCreditosClienteSelecionado().length == 0) {
            return false;
        }

        if (this.possuiCreditosPendentes()) {
            var permissoes = [];
            if (this.vencido > 0) {
                permissoes.push('TIPO_LIBERACAO_LIBERA_IMPRESSAO_NOTA_CREDITO_VENCIDA');
            }
            if (this.reimpressao > 0) {
                permissoes.push('TIPO_LIBERACAO_LIBERA_REIMPRESSAO_NOTA_CREDITO');
            }
            this.solicatarSenha(permissoes);
            return false;
        }
        return true;
    },

    listarCreditosCallback: function () {
        this.vencido = 0;
        this.reimpressao = 0;
        var self = this;

        global.ajax({
            url: "/Cliente/ListarCreditosCliente",
            type: "post",
            data: global.toJSONString({
                pesquisa: self.pesquisa
            }),
            success: function (data) {
                if (!data) {
                    return;
                }
                var m = ko.mapping.fromJS(data.Documentos);
                self.model.Documentos(m());
            }
        });
    },


    solicatarSenha: function (permissoes) {
        this.PermissaoSenhaVendaController = this.showView({
            region: {
                name: "PermissaoSenhaVenda",
                selector: "#permissao-senha-venda-region"
            },
            modal: true,
            controller: {
                type: PermissaoSenhaVendaController,
                args: {
                    permissoes: permissoes,
                    autorizadoCallback: $.proxy(this.autorizadoCallback, this)
                }
            }
        });
    },

    autorizadoCallback: function (autorizado) {
        if (autorizado) {
            this.autorizado = true;
            $('#button-imprimir-credito-cliente').click();
        };
    },

    formConfig: { /*FNX-5030 - FNX-5232*/
        selector: "#form-senha-credito-cliente",
        submit: {
            selector: "#entrar-credito-cliente",
            loadingText: "Aguarde...",
            callback: "entrar",
            type: "model",
            modelType: "knockout"
        },
        rules: {
            'Senha': {
                required: true
            }
        },
        messages: {
            'Senha': {
                required: 'O campo "Senha" é obrigatório.'
            }
        }
    },

    entrar: function (model, e) { /*FNX-5030 - FNX-5232*/

        if (e) {
            e.preventDefault();
        }

        if (!$(this.form).valid()) {
            return;
        }

        var self = this;

        var senha = $("#senhaConsultaCredidoCliente").val();

        global.ajax({
            url: "/Cliente/_ValidarPermissaoSenhaVenda",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                senha: senha,
                nomeInternoPermissao: "TIPO_LIBERACAO_CONSULTA_CREDITO_CLIENTE_ORCAMENTO",

            }),
            success: function (data) {
                global.unblockUI();
                if (!data || data.HasErrors) {
                    return;
                }
                self.model.Permitido(true);
            }
        });

    },

    cancelar: function () {

    },
});